
import Vue from "vue";
import ProgressBar from "@/components/common/ProgressBar.vue";
import CloseButton from "@/components/common/CloseButton.vue";

export default Vue.extend({
  name: "main-header",
  components: {
    ProgressBar,
    CloseButton,
  },
  data() {
    return {
      drawer: false,
      menuProgramsOpen: false,
      menuServicesOpen: false,
      showProgressBar: false,
      exceptionCaused: false,
      transportationServiceMenuItems: [
        {
          title: "Transportation Services Overview",
          to: { name: "transServicesOverview" },
        },
        { title: "Fixed Route Services", to: { name: "fixedRouteServices" } },
        { title: "Shared Ride Services", to: { name: "sharedRideServices" } },
      ],
      transportationProgramsMenuItems: [
        {
          title: "Transportation Programs Overview",
          to: { name: "transProgramOverview" },
        },
        { title: "Seniors", to: { name: "transProgramSeniors" } },
        {
          title: "Persons with Disabilities",
          to: { name: "transProgramPersonWDis" },
        },
        {
          title: "Low Income Individuals",
          to: { name: "transProgramLowIncomeInd" },
        },
      ],
    };
  },
  computed: {
    menuClass: function () {
      return (route: string) => {
        let mclass = "";

        if (route === "services") {
          mclass = this.isTransServicePath ? "activeLink" : "";
        } else if (route === "progams") {
          mclass = this.isTransProgramPath ? "activeLink" : "";
        }
        return mclass;
      };
    },
    isTransServicePath(): boolean {
      return this.$route.path.indexOf("/home/transportation-services") !== -1;
    },
    isTransProgramPath(): boolean {
      return this.$route.path.indexOf("/home/transportation-progams") !== -1;
    },
  },
  methods: {
    isSameRouteAsNow(paramStr: string) {
      // get comparable fullPaths
      let from = this.$route.fullPath;
      let to = this.$router.resolve({ name: paramStr }).route.fullPath;

      return from === to;
    },
  },
});
